import * as React from "react"
import { Link } from "gatsby"
import HubspotForm from 'react-hubspot-form'
import Layout from "../layout"

const SOCIAL = [
    { href: "https://www.facebook.com/vibrahub", label: "Facebook", icon: "social_facebook" },
    { href: "https://www.instagram.com/vibrahub/", label: "Instagram", icon: "social_instagram" },
    { href: "https://www.pinterest.com/vibrahub/", label: "Pinterest", icon: "social_pinterest" },
]

/**
 * Shared contact page: HubSpot form, social links and contact details.
 * `title` and `intro` distinguish the general contact page from the demo booking page.
 */
export default function ContactPage({ seo, title, intro }) {
    return (
        <Layout seo={seo}>
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="row breadcrumb_box  align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-6 text-center text-sm-left">
                                    <h1 className="breadcrumb-title">{title}</h1>
                                </div>
                                <div className="col-lg-6  col-md-6 col-sm-6">
                                    <ul className="breadcrumb-list text-center text-sm-right">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active">{title}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="site-wrapper-reveal border-bottom">
                <div className="contact-us-page-warpper mt-30 section-space--pb_120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                {intro}
                                <HubspotForm
                                    portalId='7653384'
                                    formId='0bdaac17-4c5b-4fe7-87a2-e0f1c36a688d'
                                    loading={<div>Loading the form…</div>}
                                />
                                <p style={{ marginTop: 20, color: '#777', fontSize: '0.95rem' }}>
                                    Prefer email? Write to <a href="mailto:info@vibrahub.com">info@vibrahub.com</a> and we will reply within one working day.
                                </p>
                            </div>
                            <div className="col-lg-4 ml-auto">
                                <div className="conatact-info-text section-space--mt_60">
                                    <div className="product_socials mt-30">
                                        <span className="label">FOLLOW US:</span>
                                        <ul className="helendo-social-share socials-inline">
                                            {SOCIAL.map((s) => (
                                                <li key={s.href}>
                                                    <a href={s.href} aria-label={s.label} target="_blank" rel="noopener noreferrer">
                                                        <i className={`social ${s.icon}`}></i>
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contact-us-info-area section-space--mb_60 border-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="single-contact-info-item">
                                    <div className="icon">
                                        <i className="icon-clock3"></i>
                                    </div>
                                    <div className="iconbox-desc">
                                        <h6 className="mb-10">Hours</h6>
                                        <p>Monday to Friday, 8:30 to 18:00 CET<br />(7:30 to 17:00 UK time)</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="single-contact-info-item">
                                    <div className="icon">
                                        <i className="icon-telephone"></i>
                                    </div>
                                    <div className="iconbox-desc">
                                        <h6 className="mb-10">Phone</h6>
                                        <p>UK <a href="tel:+447544073294">+44 7544 073 294</a><br />Slovenia <a href="tel:+38670293029">+386 70 293 029</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="single-contact-info-item">
                                    <div className="icon">
                                        <i className="icon-envelope-open"></i>
                                    </div>
                                    <div className="iconbox-desc">
                                        <h6 className="mb-10">Email</h6>
                                        <p><a href="mailto:info@vibrahub.com">info@vibrahub.com</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
